import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import MainMenu from '../main-menu';

// Boilerplate
import 'semantic-ui-css/semantic.min.css';
import '../index.css';

//import * as Lw from 'wrld.js';

//const Lw = window.Lw;

export default class MainWrld extends Component {

    render() {
        return (
            <MainMenu mapRender={<div id="wmap" className="mapStyle"></div>}
                loadMap={this.loadMap} history={this.props.history}
                ag = {this.props.ag} />
        );

        // return (<div id="wmap" className="mapStyle"></div>);
    }

    loadMap = () =>
    {
        //const Lw = require('wrld.js');
        //console.log("loading map");
        //console.log(window.Lw);
        //const Lw = window.Lw;

        //this.map = Lw.map("wmap", "816e1b7f836621b9687372c0c6ee1195", {
        //    center: [46.897753, -96.802437],
        //    zoom: 16
        //});

        //this.map.themes.setWeather(Lw.themes.weather.Snowy);
        //this.map.themes.setTime(Lw.themes.time.Night);

        //var marker = Lw.marker([46.897753, -96.802437], { title: "Next level stuff" }).addTo(this.map);
        //marker.bindPopup("Next level stuff.");
    }

    onClickMarker = (e) => {
    }

    componentDidMount() {
        //this.loadMap();
    }
}


// WEBPACK FOOTER //
// ./src/maps/map-wrld.js